import { environment } from "environments/environment";

export const preScreenInfo = {
    hasPrescreening: environment.HAS_PRESCREENING,
    preScreenProvider: environment.PRESCREEN_PROVIDER
}
export const preScreenStatus = {
    success: 'approved',
    fail: 'not_approved'
}